// Relevant signature type codes. Other options are
// portal - 1
// email - 2
// paper - 3
// oral agreement - 5

export const CONTRACT_SIGNATURE_TYPE_CODE_TABLET = 4
export const CONTRACT_SIGNATURE_TYPE_CODE_BANKID = 6

export const PRICE_LIST_ALLOCATION_CODE_DYNAMIC = 1
export const PRICE_LIST_ALLOCATION_CODE_STATIC = 2

export const MIN_FORESTFUND_RATE = 4
export const DEFAULT_FORESTFUND_RATE = 25
export const MAX_FORESTFUND_RATE = 40

export const MAX_OPERATION_PRICE = 999

export const CONTRACT_FIELD_COLLECTIONPOINT_LENGTH_MIN = 3
export const CONTRACT_FIELD_COLLECTIONPOINT_LENGTH_MAX = 40

export const CONTRACT_TYPE_FOREST_OPERATION = 1
export const CONTRACT_TYPE_SILVICULTURE_ORDER = 2
export const CONTRACT_TYPE_REGISTRATION = 3
export const CONTRACT_TYPE_SUPPLY_WOOD = 4
export const CONTRACT_TYPE_SILVICULTURE_AGREEMENT = 5

export const ENTITY_TYPE_CONTRACT = 1
export const ENTITY_TYPE_QUOTE = 2

export const CONTRACT_TYPES = [
  {
    Id: CONTRACT_TYPE_FOREST_OPERATION,
    Name: 'TYPE_FOREST_OPERATION',
    NewLabel: 'NEW_TYPE_FOREST_OPERATION'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_ORDER,
    Name: 'TYPE_SILVICULTURE_ORDER',
    NewLabel: 'NEW_TYPE_SILVICULTURE_ORDER'
  },
  {
    Id: CONTRACT_TYPE_REGISTRATION,
    Name: 'TYPE_REGISTRATION',
    NewLabel: 'NEW_TYPE_REGISTRATION'
  },
  {
    Id: CONTRACT_TYPE_SUPPLY_WOOD,
    Name: 'TYPE_SUPPLY_WOOD',
    NewLabel: 'NEW_TYPE_SUPPLY_WOOD'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    Name: 'TYPE_SILVICULTURE_AGREEMENT',
    NewLabel: 'NEW_TYPE_SILVICULTURE_AGREEMENT'
  }
]

export const CONTRACT_TYPES_ICONS = [
  {
    Id: CONTRACT_TYPE_FOREST_OPERATION,
    Name: 'spot/felling'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_ORDER,
    Name: 'spot/large/silviculture'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    Name: 'spot/large/silviculture'
  },
  {
    Id: CONTRACT_TYPE_REGISTRATION,
    Name: 'spot/transport-process'
  },
  {
    Id: CONTRACT_TYPE_SUPPLY_WOOD,
    Name: 'spot/milling-process'
  }
]

export const CONTRACT_PERIODS = [
  {
    Id: 1,
    Name: 'PERIOD_WINTER'
  },
  {
    Id: 2,
    Name: 'PERIOD_SPRING'
  },
  {
    Id: 3,
    Name: 'PERIOD_SUMMER'
  },
  {
    Id: 4,
    Name: 'PERIOD_FALL'
  }
]

export const CONTRACT_COMPLETIONS = [
  {
    Id: 1,
    Name: 'COMPLETION_AGREED_VOLUME'
  },
  {
    Id: 2,
    Name: 'COMPLETION_AGREED_AREA'
  }
]

export const CONTRACT_OPERATION_COST_TYPE = [
  {
    value: 1,
    text: 'OPERATION_PRICE_FIXED_PRICE_SHORT',
    subText: 'KR_M_UNDER_BARK',
    key: '1'
  },
  {
    value: 2,
    text: 'OPERATION_PRICE_SUGGESTED_RETAIL_SHORT',
    subText: 'KR_M_UNDER_BARK',
    key: '2'
  },
  {
    value: 3,
    text: 'HOURLY_ASSIGNMENTS',
    subText: 'KR_PER_HOUR',
    key: '3'
  }
]

export const NEW_CONTRACT_OPTIONS = [
  {
    key: 'forestoperation',
    value: CONTRACT_TYPE_FOREST_OPERATION,
    text: 'TYPE_FOREST_OPERATION',
    subText: 'TYPE_FOREST_OPERATION_DESC',
    icon: 'spot/large/felling'
  }, {
    key: 'supplywood',
    value: CONTRACT_TYPE_SUPPLY_WOOD,
    text: 'TYPE_SUPPLY_WOOD',
    subText: 'TYPE_SUPPLY_WOOD_DESC',
    icon: 'spot/large/mill'
  },
  {
    key: 'silvicultureagreement',
    value: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    text: 'TYPE_SILVICULTURE_AGREEMENT',
    subText: 'TYPE_SILVICULTURE_AGREEMENT_DESC',
    icon: 'spot/large/silviculture'
  },
  {
    key: 'silvicultureorder',
    value: CONTRACT_TYPE_SILVICULTURE_ORDER,
    text: 'TYPE_SILVICULTURE_ORDER',
    subText: 'TYPE_SILVICULTURE_ORDER_DESC',
    icon: 'spot/large/tree-rounded'
  },
  {
    key: 'registration',
    value: CONTRACT_TYPE_REGISTRATION,
    text: 'TYPE_REGISTRATION',
    subText: 'TYPE_REGISTRATION_DESC',
    icon: 'spot/large/transport'
  },
]

export const NEW_CONTRACT_TYPE_OPTIONS = [
  {
    key: 'forestoperation',
    value: CONTRACT_TYPE_FOREST_OPERATION,
    text: 'Vanlig driftsavtale',
    subText: 'Glommen Mjøsen håndterer drift, sertifisering og foryngelse'
  }, {
    key: 'registration',
    value: CONTRACT_TYPE_REGISTRATION,
    text: 'Innmelding',
    subText: 'Glommen Mjøsen håndterer transport og salg'
  }, {
    key: 'supplywood',
    value: CONTRACT_TYPE_SUPPLY_WOOD,
    text: 'Leveransevirke',
    subText: 'Glommen Mjøsen håndterer salg'
  }
]

export const SILVI_CULTURE = [
  {
    Name: 'IS_GROUND_PREPARED',
    Field: 'IsGroundPrepared',
    Required: false
  },
  {
    Name: 'SKID_ROAD',
    Field: 'SkidRoad',
    Required: false
  },
  {
    Name: 'ENVIRONMENTAL_CONDITIONS',
    Field: 'EnvironmentalConditions',
    Required: false
  },
  {
    Name: 'OPERATION_ROAD_LENGTH',
    Field: 'OperationRoadLength500',
    Required: false
  },
  {
    Name: 'FALL_PLANTING',
    Field: 'FallPlanting',
    Required: false
  },
  {
    Name: 'BARRIER_KEYS',
    Field: 'BarrierKeys',
    Required: false
  },
  {
    Name: 'FOREST_OWNER_TRANSPORTS_PLANTS',
    Field: 'ForestOwnerTransportsPlants',
    Required: false
  },
  {
    Name: 'NEED_YOUNG_FOREST_CARE_ASSESSED_ON_PROPERTY',
    Field: 'NeedYoungForestCareAssessedOnProperty',
    Required: true,
    Group: 'YOUNG_FOREST_CARE'
  },
  {
    Name: 'NEED_YOUNG_FOREST_CARE',
    Field: 'NeedYoungForestCare',
    Required: true,
    Group: 'YOUNG_FOREST_CARE'
  },
  {
    Name: 'PLAN_IMPLEMENTATION_OF_YOUNG_FOREST_CARE',
    Field: 'PlanImplementationOfYoungForestCare',
    Required: true,
    Group: 'YOUNG_FOREST_CARE'
  }
]

/**
 * Contract activation wait time after making changes that need syncing
 */
export const MS_DELAY_CRM_TO_VH_SYNC = 1000 /*ms*/ * 90 /*seconds*/

/** Interval for running cleanup-routine, clearing old entries */
export const MS_INTERVAL_CLEAN_MODIFIED_TIMESTAMPS = 1000 /*ms*/ * 60 /*seconds*/ * 5 /*minutes*/

